import { render, staticRenderFns } from "./DataLoggerPage.vue?vue&type=template&id=6c3b5676&scoped=true&"
import script from "./DataLoggerPage.vue?vue&type=script&lang=ts&"
export * from "./DataLoggerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b5676",
  null
  
)

export default component.exports